import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap-button-loader';
import { show } from 'redux-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AdvertiserApi } from '../../../../api';
import { Spinner } from '../../../../components/common';
import InvoicesPopup from '../../../../components/advertisers/invoices/InvoicesPopup';
import { convertCentsToDollars, currencyFormat } from '../../../../utils/helpers/currency';
import { setLoader, removeLoader } from '../../../../actions';
import { ButtonShow } from '../../../../components/common/buttons/actions';

class Index extends Component {
  componentWillMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    const { account, dispatch } = this.props;
    if (account.uuid) {
      const data = { ...params, account_id: account.uuid, id: account.uuid };
      dispatch(AdvertiserApi.actions.invoices.get(data));
    }
  }

  calculateOwing = ({ data }) => {
    const owing = data.reduce((acc, invoice) => { return invoice.status !== 'paid' ? acc + invoice.amount_remaining : acc; }, 0);
    return convertCentsToDollars(owing);
  }

  calculateSpend = ({ data }) => {
    const paidInvoices = data.filter((invoice) => (invoice.status === 'paid'));
    const spend = paidInvoices.length ? paidInvoices[0].total : 0;
    return convertCentsToDollars(spend);
  }

  payInvoices = () => {
    const { account, dispatch } = this.props;
    if (account.uuid) {
      dispatch(setLoader('payingInvoices'));
      const data = { account_id: account.uuid, id: account.uuid };
      dispatch(AdvertiserApi.actions.payInvoices.get(data, (error, success) => {
        dispatch(removeLoader('payingInvoices'));
        if (success) {
          toastr.success(success.message);
          dispatch(AdvertiserApi.actions.customers());
        } else if (error) {
          if (error.responseJSON.error.billing !== undefined) {
            error.responseJSON.error.billing.map((err) => toastr.error(err.message));
          }
        }
        dispatch(setLoader('gettingInvoices'));
        dispatch(AdvertiserApi.actions.invoices.get(data, () => {
          dispatch(removeLoader('gettingInvoices'));
        }));
      }));
    }
  }

  sanitizePayPeriod = (c, inv) => {
    let pay_period = '';
    for (const period of c) {
      const month = period === null ?
        moment.unix(+inv.date).format('MMMM') :
        moment(new Date(period)).add(1, 'months').format('MMMM');
      pay_period += pay_period === '' ? month : `/${month}`;
    }
    return pay_period;
  }

  handleShow = (c, r) => {
    const { dispatch } = this.props;

    dispatch(show('InvoiceModal', {
      invoice: r
    }));
  }

  renderActions = (c, r) => {
    return (
      <ul className='list-inline'>
        <li>
          <ButtonShow
            onClick={() => this.handleShow(c, r)}
          />
        </li>
      </ul>
    );
  }

  render() {
    const { isLoading, isPaying, invoices } = this.props;
    const { data } = invoices || {};

    const spend = invoices.data !== undefined && this.calculateSpend(invoices);
    const owing = invoices.data !== undefined && this.calculateOwing(invoices);

    return (
      <div>
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12"><div className="ibox">
            <div className="ibox-title"><h5>Last Amount Paid</h5></div>
            <div className="ibox-content"><h1>{spend ? currencyFormat(spend) : '-'}</h1></div>
          </div></div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12"><div className="ibox">
            <div className="ibox-title"><h5>Outstanding Balance</h5></div>
            <div className="ibox-content">
              <h1>
                {owing ? currencyFormat(owing) : '-'}
              </h1>
            </div>
          </div></div>
        </div>
        <div className='row'>
          <div className="col-xs-12">
            <div className='ibox'>
              <div className='ibox-title'>
                <h5>Invoices</h5>
                <div>
                  {
                    owing !== '0.00' &&
                    (
                      <Button
                        bsSize='small'
                        className='pull-right'
                        bsStyle='primary'
                        style={{ minWidth: '150px' }}
                        loading={isPaying}
                        onClick={() => this.payInvoices()}
                      >
                        {isPaying ? 'Paying...' : <span><FontAwesomeIcon icon="credit-card" /> Pay Balance</span>}
                      </Button>
                    )
                  }
                </div>
              </div>
              <div className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}>
                <Spinner />

                <BootstrapTable
                  striped
                  ref='InvoicesTable'
                  data={data || []}
                >
                  <TableHeaderColumn
                    width="50"
                    dataField="status"
                    dataFormat={(c) => (c === 'paid' ?
                      <FontAwesomeIcon icon="check-circle" color='green' /> :
                      <FontAwesomeIcon icon="times-circle"  color='red' />)
                    }
                  >
                    Paid
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="100"
                    dataField="pay_period"
                    dataFormat={(c, r) => this.sanitizePayPeriod(c, r)}
                  >
                    Period
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="100"
                    dataField="date"
                    dataFormat={(c) => moment.unix(c).format('MM/DD/YYYY')}
                  >
                    Date Issued
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="200"
                    dataField="total"
                    dataFormat={(c) => currencyFormat(convertCentsToDollars(c))}
                  >
                    Total
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    width="200"
                    dataField="number"
                  >
                    Invoice #
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    isKey
                    width="100"
                    dataField="uuid"
                    dataFormat={this.renderActions}
                  >
                    Actions
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
            <InvoicesPopup />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loader, advertiser: { invoices: { data: invoices, loading }, accounts } } = state;
  const isPaying = loader.includes('payingInvoices') || loading ? true : false;
  const isLoading = loader.includes('gettingInvoices') || loading ? true : false;
  const accountSlug = ownProps.params.accountSlug;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};

  return { invoices, isLoading, isPaying, account };
};

export default connect(mapStateToProps)(Index);
